<template>
        <v-row dense>
            <v-col cols="12" class="mb-3">
                <v-card elevation="3" :loading="loading">
                    <v-card-title class="text-subtitle-1 font-weight-bold">
                        Deadlines of Submissions
                        <v-divider class="my-2"></v-divider>
                    </v-card-title>
                    <v-card-text>
                        <v-row class="d-flex">
                            <v-col v-for="d in deadlinesData" :key="d" class="d-flex flex-column flex-md-row justify-start align-left align-lg-center ga-2">
                                <div v-if="d.term_id != null"><b>{{ d.term.name }}</b></div>
                                <v-chip>
                                    Deadline: &nbsp; <b>{{ formatDate(d.deadline) }}</b>
                                </v-chip>
                                <v-chip v-if="d.is_extended == true">
                                    Deadline Extension: &nbsp; <b>{{ formatDate(d.deadline_extension) }}</b>
                                </v-chip>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
            <!-- <v-col cols="12" md="6" class="mb-3">
                <v-card elevation="3" :loading="loading">
                    <v-card-title class="text-subtitle-1 font-weight-bold">
                        Submission Statuses
                        <v-divider class="my-2"></v-divider>
                    </v-card-title>
                    <v-card-text>
                        <v-row class="d-flex">
                            <v-col class="d-flex flex-column flex-md-row justify-start align-left align-lg-center ga-2">
                                <v-chip color="green" variant="elevated">Total Faculties: 50</v-chip>
                                <v-chip color="orange-darken-1" variant="elevated">Total Submissions: 50</v-chip>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col> -->
            <v-col cols="12">
                <v-tabs
                    v-model="tab"
                    color="darkGreen"
                    @update:model-value="init(compliance)"
                    >
                    <v-tab value="department" :class="{'font-weight-black': tab == 'department'}">{{ $store.state.user.program?.abbrev }} Faculty</v-tab>
                    <v-tab value="requested" :class="{'font-weight-black': tab == 'requested'}">Faculty in other programs</v-tab>
                </v-tabs>
            </v-col>
            <v-col cols="12" md="4">
                <v-text-field
                    v-model="search"
                    variant="outlined"
                    prepend-inner-icon="mdi-magnify"
                    label="Search"
                    density="comfortable"
                    solo
                    hide-details
                    rounded="lg"
                    color="primary"
                ></v-text-field>
            </v-col>
            <v-col v-if="tab == 'department'" class="text-right" cols="12" md="8">
                <v-btn
                @click="showSubmitDialog()"
                prepend-icon="mdi-plus"
                class="mt-1 rounded-lg"
                color="routesColor"
                height="40px"
                elevation="2">
                    Add Compliance Check
                </v-btn>
            </v-col>
            <v-col v-if="tab == 'requested'" class="text-right" cols="12" md="8">
                <v-btn
                @click="showAddComplianceCheckingForRequested()"
                prepend-icon="mdi-plus"
                class="mt-1 rounded-lg"
                color="routesColor"
                height="40px"
                elevation="2">
                    Add Compliance Check for Requested Faculty
                </v-btn>
            </v-col>
            <v-col cols="12">
                <v-row dense>
                    <v-col cols="12">
                        <v-card class="dt-container mt-2">    
                            <v-data-table
                                :mobile="isMobileOrTablet()"
                                :headers="headers"
                                :items="tableItems"
                                :search="search"
                                :loading="loading"
                                :items-per-page="15"
                                :items-per-page-options="[15,30, 50, 100, -1]"
                            >
                            <template v-slot:loading>
                                <v-progress-linear indeterminate color="primary" height="5" class="mt-1 rounded-lg"></v-progress-linear>
                            </template>
                            <template v-slot:item.submittedBy="{ item }">{{ item.submittedBy }}</template>
                            <template v-slot:item.latestSubmissionDate="{ item }">
                                <span>{{ formatDate(item.latestSubmissionDate)}} </span>
                            </template>
                            <template v-slot:[`item.action`]="{ item }">
                                    <v-btn v-if="tab == 'department'" size="small" @click="showViewDialog(item.user)" variant="outlined" text="View" color="green-accent-4" elevation="2"></v-btn>
                                    <v-btn v-if="tab == 'requested'" size="small" @click="showUpdateComplianceCheckingForRequested(item.user)" variant="outlined" text="View" color="green-accent-4" elevation="2"></v-btn>
                            </template>
                            </v-data-table>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>

        <ComplianceCheckingDialog ref="ComplianceCheckingDialog" @refresh="init(compliance)"/>
        <ComplianceCheckingForRequested ref="ComplianceCheckingForRequested" @refresh="init(compliance)"/>
</template>

<script>
import axios from 'axios';
import { defineComponent } from 'vue';
import ComplianceCheckingDialog from '../Dialogs/ComplianceCheckingDialog.vue';
import ComplianceCheckingForRequested from '../Dialogs/ComplianceCheckingForRequested.vue';

export default defineComponent({
    components: {
        ComplianceCheckingDialog,
        ComplianceCheckingForRequested
    },
    computed: {
        tableItems() {
            return this.data.map((d) => ({
                ...d,
                submittedBy: `${d.user.fname ?? ''} ${d.user.lname ?? ''}`.trim()
            }));
        }
    },
    data(){
        return {
            data: [],
            search: null,
            loading: false,
            tab: 'department',

            headers: [
                { title: 'Faculty Name', align: 'start', sortable: true, key: 'submittedBy' },
                { title: 'Submission Count', align: 'start', sortable: true, key: 'submissionCount' },
                { title: 'Total Course Load', align: 'start', sortable: true, key: 'totalFacultyLoad' },
                { title: 'Lastest Submission Date', align: 'start', sortable: true, key: 'latestSubmissionDate' },
                { title: 'Actions', align: 'end', sortable: false, key: 'action' },
            ],

            compliance: [],
            deadlinesData: [],

            smAndDown: false
        }
    },
    methods: {
        init(data){
            this.compliance = data
            this.deadlinesData = data.schedules

            this.loading = true
            const token = localStorage.getItem('aums-token')

            if(this.tab == 'department'){
                axios.get(process.env.VUE_APP_SERVER_URL + '/compliance-upload-details/findAllCompliancesDetailsByProgramAndSemester/' + this.$store.state.user.program.id + '/' + this.compliance.id + '/' + this.$store.state.semester_schoolyear.id,
                { headers:
                    { 
                        'Authorization': `Bearer ${token}`,
                    }
                }
                ).then((res)=>{
                    if(res.data){
                        this.loading = false
                        this.data = res.data
                    }
                }).catch((error)=>{
                    if(error.response.status == 401){
                        this.loading = false

                        localStorage.removeItem("vuex");
                        localStorage.removeItem("aums-token");
                        window.location.reload();
                    }
                    else{
                        console.log(error)
                    }
                });
            }
            else if(this.tab == 'requested'){
                axios.get(process.env.VUE_APP_SERVER_URL + '/compliance-upload-details/findAllCompliancesDetailsByCheckerAndSemester/' + this.$store.state.user.id + '/' + this.compliance.id + '/' + this.$store.state.semester_schoolyear.id,
                { headers:
                    { 
                        'Authorization': `Bearer ${token}`,
                    }
                }
                ).then((res)=>{
                    if(res.data){
                        this.loading = false
                        this.data = res.data
                    }
                }).catch((error)=>{
                    if(error.response.status == 401){
                        this.loading = false

                        localStorage.removeItem("vuex");
                        localStorage.removeItem("aums-token");
                        window.location.reload();
                    }
                    else{
                        console.log(error)
                    }
                });
            }
        },
        showSubmitDialog(){
            this.$refs.ComplianceCheckingDialog.initAdd(this.compliance)
        },
        showViewDialog(user){
            this.$refs.ComplianceCheckingDialog.initUpdate(user, this.compliance)
        },
        showAddComplianceCheckingForRequested(){
            this.$refs.ComplianceCheckingForRequested.initAdd(this.compliance)
        },
        showUpdateComplianceCheckingForRequested(user){
            this.$refs.ComplianceCheckingForRequested.initUpdate(user, this.compliance)
        },
    },
})
</script>

<style scoped>

</style>